"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StickerDto = exports.StickerAuthorDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class StickerAuthorDto {}
exports.StickerAuthorDto = StickerAuthorDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], StickerAuthorDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Null until the viewer is checked in at this venue (or is the author); show blurredImageUrl instead.'
}), __metadata("design:type", Object)], StickerAuthorDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], StickerAuthorDto.prototype, "blurredImageUrl", void 0);
class StickerDto {}
exports.StickerDto = StickerDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], StickerDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], StickerDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], StickerDto.prototype, "caption", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], StickerDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Null when the author chose "Keep it on my profile".'
}), __metadata("design:type", Object)], StickerDto.prototype, "expiresAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], StickerDto.prototype, "keepOnProfile", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: '"Pinned by the Venue": pinned moments are listed first.'
}), __metadata("design:type", Boolean)], StickerDto.prototype, "isPinned", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], StickerDto.prototype, "likeCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], StickerDto.prototype, "likedByMe", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: StickerAuthorDto
}), __metadata("design:type", StickerAuthorDto)], StickerDto.prototype, "author", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], StickerDto.prototype, "isAuthor", void 0);
//# sourceMappingURL=Sticker.dto.js.map